import React, { useState } from 'react';
import axios from 'axios';
import { useAppId } from '../context/AppIdContext';
import { VOTER_ORANGE, voterIcons } from './voterCardIcons';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const WhatsappSlipButton = ({ voter, color, icon }) => {
    // ✅ ADDED aacharSahita here
    const { appId, language, userId, userName, whtspApi, wtspDeviceId, aacharSahita } = useAppId();
    const [isSending, setIsSending] = useState(false);
    
    const lang = language || 'en';

    const t = {
        en: { slip: "Slip", notAvailable: "Mobile number is not available.", fetchError: "Could not fetch family details.", error: "Error generating message." },
        hi: { slip: "पर्ची", notAvailable: "मोबाइल नंबर उपलब्ध नहीं है।", fetchError: "परिवार का विवरण प्राप्त नहीं किया जा सका।", error: "संदेश बनाने में त्रुटि।" },
        gu: { slip: "સ્લિપ", notAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.", fetchError: "કુટુંબની વિગતો મેળવી શકાઈ નહીં.", error: "સંદેશ બનાવવામાં ભૂલ." }
    };
    const txt = t[lang];

    const handleWhatsAppShare = async (e) => {
        if (e) e.stopPropagation(); 

        if (!voter || !voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
            alert(txt.notAvailable);
            return;
        }

        setIsSending(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id || voter.idcard_no,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;

                // Safely extract the banner URL from result2 using the "img" key
                let apiBannerUrl = "";
                if (response.data.data.result2) {
                    if (Array.isArray(response.data.data.result2) && response.data.data.result2.length > 0) {
                        apiBannerUrl = response.data.data.result2[0]?.img || response.data.data.result2[0]?.image_url || response.data.data.result2[0]?.url || response.data.data.result2[0]?.image || response.data.data.result2[0];
                    } else if (typeof response.data.data.result2 === 'string') {
                        apiBannerUrl = response.data.data.result2;
                    }
                }
                
                // Fallback banner if result2 is empty
                const bannerDataUrl = apiBannerUrl || "https://rajkotcorporation.bjpwings.com/img/prachar/19042026030352_1.jpg";

                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                // Function to handle pure text fallback
                const sendTextFallback = () => {
                    let message = "";
                    familyMembers.forEach((member, index) => {
                        message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                        message += `${member.full_name}\n`;
                        message += `${member.middle_name}\n`;
                        message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                        message += `${member.idcard_no}\n`;
                        message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                        message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                        if (index < familyMembers.length - 1) {
                            message += `----------------------------------------\n\n`;
                        }
                    });
                    const encodedMessage = encodeURIComponent(message);
                    window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');
                };

                // --- ADVANCED SLIP SENDING (Using the Stream API Backend) ---
                if (Number(whtspApi) === 1 && wtspDeviceId) {
                    try {
                        // 1. Format the family members exactly how the Stream API expects
                        const formattedVoters = familyMembers.map(member => {
                            let partNo = String(voter.part_no);
                            let boothNo = String(voter.part_no);
                            let serialNo = String(voter.slnoinpart);

                            // Extract precise numbers from "ભાગ નં - 69  બૂથ નં - 56  ક્રમ નં. - 1130"
                            if (member.first_detail) {
                                const pMatch = member.first_detail.match(/ભાગ નં\s*-\s*(\d+)/);
                                if (pMatch) partNo = pMatch[1];
                                
                                const bMatch = member.first_detail.match(/બૂથ નં\s*-\s*(\d+)/);
                                if (bMatch) boothNo = bMatch[1];
                                
                                const sMatch = member.first_detail.match(/ક્રમ નં\.\s*-\s*(\d+)/);
                                if (sMatch) serialNo = sMatch[1];
                            }

                            const cleanName = member.full_name ? member.full_name.replace('નામ :', '').trim() : '';
                            const cleanGenderAge = member.sex_age ? member.sex_age.replace('જાતિ/ઉમર :', '').trim() : '';
                            const cleanIdCard = member.idcard_no ? member.idcard_no.replace('આઇડિકાર્ડ :', '').replace('આઈડિકાર્ડ :', '').trim() : '';
                            const cleanAddress = member.eng_polling_location || member.polling_location || '';

                            return {
                                partNo: partNo,
                                boothNo: boothNo,
                                serialNo: serialNo,
                                name: cleanName,
                                genderAge: cleanGenderAge,
                                idCard: cleanIdCard,
                                address: cleanAddress,
                                mobile: mobile
                            };
                        });

                        // ✅ NEW: Achar Shahita Logic
                        let finalBannerUrl = bannerDataUrl;
                        let finalAgentName = userName || "Agent";
                        let finalCompanyName = "HL Group Of Companies";

                        if (String(aacharSahita) === "1") {
                            finalBannerUrl = "";
                            finalAgentName = "";
                            finalCompanyName = "";
                        }

                        // 2. Prepare Payload for Stream API
                        const payload = {
                            deviceId: String(wtspDeviceId),
                            bannerUrl: finalBannerUrl,
                            agentName: finalAgentName,
                            companyName: finalCompanyName,
                            customEndpoint: "https://hlele.bjpwings.com/InsLogHandler.ashx",
                            appId: appId ? String(appId) : "1",
                            userId: userId ? String(userId) : "123456",
                            voters: formattedVoters
                        };

                        // 3. Call the Stream API (jevirite bulk slip page ma karelche)
                        const streamRes = await fetch("https://whatsapp.hlgroups.in/api/send-voter-slips-stream", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'x-api-key': 'my_secret_key_123'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!streamRes.body) throw new Error("ReadableStream not supported.");

                        const reader = streamRes.body.getReader();
                        
                        // Keep reading the stream until backend finishes sending all family slips
                        while (true) {
                            const { done } = await reader.read();
                            if (done) break;
                        }

                        alert("Family slip(s) sent successfully via WhatsApp!");
                    } catch (err) {
                        console.error("Error sending slip via stream API:", err);
                        alert("API error. Sending standard text message instead.");
                        sendTextFallback();
                    } finally {
                        setIsSending(false);
                    }

                } else {
                    // Fallback to text-only wa.me redirect if API is not active
                    sendTextFallback();
                    setIsSending(false);
                }
            } else {
                alert(txt.fetchError);
                setIsSending(false);
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert(txt.error);
            setIsSending(false);
        }
    };

    return (
        <button
            onClick={handleWhatsAppShare}
            disabled={isSending}
            className="action-btn-wrapper"
            style={{ 
                textDecoration: 'none', 
                background: 'none', 
                border: 'none', 
                cursor: isSending ? 'wait' : 'pointer', 
                padding: 0,
                opacity: isSending ? 0.6 : 1
            }}
        >
            <div className="circle-btn" style={{ backgroundColor: color || VOTER_ORANGE }}>
                {isSending ? '⏳' : (icon || voterIcons.slip)}
            </div>
            <span className="btn-label">{txt.slip}</span>
        </button>
    );
};

export default WhatsappSlipButton;